import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Ticket, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const PagamentoSucessoPage = () => {
  const [searchParams] = useSearchParams();
  const participanteId = searchParams.get('ref') || searchParams.get('external_reference');
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkStatus = async () => {
      if (!participanteId) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/payments/mercadopago/status/${participanteId}`);
        if (response.ok) {
          const data = await response.json();
          setStatus(data);
        }
      } catch (err) {
        console.error('Error checking status:', err);
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
    // Poll for status updates every 5 seconds for 30 seconds
    const interval = setInterval(checkStatus, 5000);
    const timeout = setTimeout(() => clearInterval(interval), 30000);
    
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [participanteId]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4" data-testid="pagamento-sucesso-page">
      <div className="max-w-lg w-full text-center">
        {/* Success Icon */}
        <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-green-500/20 flex items-center justify-center animate-pulse">
          <CheckCircle className="w-12 h-12 text-green-500" />
        </div>

        <h1 className="font-display text-3xl md:text-4xl text-white mb-4">
          Pagamento Aprovado!
        </h1>

        <p className="text-gray-400 text-lg mb-8">
          Sua inscrição para o <span className="text-white font-semibold">Encontro de Casais Kairós 2026</span> foi confirmada com sucesso.
        </p>

        {loading ? (
          <div className="flex items-center justify-center gap-2 text-gray-400 mb-8">
            <Loader2 className="w-5 h-5 animate-spin" />
            <span>Verificando confirmação...</span>
          </div>
        ) : status?.codigo_ingresso ? (
          <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-8">
            <div className="flex items-center justify-center gap-2 text-kairos-orange mb-2">
              <Ticket className="w-5 h-5" />
              <span className="font-semibold">Código do Ingresso</span>
            </div>
            <p className="text-2xl font-mono text-white tracking-wider">
              {status.codigo_ingresso}
            </p>
          </div>
        ) : (
          <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 mb-8">
            <p className="text-yellow-400 text-sm">
              Aguardando confirmação do pagamento. Isso pode levar alguns instantes.
            </p>
          </div>
        )}

        <div className="space-y-4">
          <p className="text-gray-500 text-sm">
            Você receberá um e-mail de confirmação com todos os detalhes da sua inscrição.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/minha-inscricao">
              <Button className="bg-kairos-orange hover:bg-kairos-orange-dark text-white px-8">
                Acessar Portal do Participante
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            
            <Link to="/">
              <Button variant="outline" className="border-white/20 text-gray-300 hover:bg-white/5">
                Voltar ao Início
              </Button>
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-gray-500 text-sm">
            Dúvidas? Entre em contato pelo WhatsApp: (69) 99999-9999
          </p>
        </div>
      </div>
    </div>
  );
};

export default PagamentoSucessoPage;
